import React from "react";
import { Text, View } from "@react-pdf/renderer";

import { styles } from "../styles";
import { Totals } from "./Totals";

import { translate } from "../translate";
import { hideTotals } from "../utils/calculateTotals";

export const OrderTotalsBox = ({ order }) => {
  const showTotals = !hideTotals(order);

  return (
    <View style={styles.box} wrap={false}>
      {showTotals && (
        <Text style={styles.rowHeader}>{translate("totalAmount")}</Text>
      )}
      <Totals order={order} totals={order.totals} />
    </View>
  );
};
